import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useContext } from 'react';
import get from 'lodash/get';
import { formatMessage, formatPriceWithVatRate } from '../../utils/strings';
import PricesContext from './PricesContext';

const ContentTable = ({ tableHead, tableBody }) => {
  const { domesticPrices } = useContext(PricesContext);

  return (
    <Table sx={{ maxWidth: '600px', mx: 'auto', mt: 4 }}>
      <TableHead>
        <TableRow>
          {tableHead.map((tableHeadItem, index) => (
            <TableCell key={index} sx={{ fontWeight: 'bold' }}>
              {tableHeadItem}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {tableBody.map((tableRow, index) => (
          <TableRow key={index}>
            {tableRow.map((tableCell, index) => {
              const value = tableCell.priceKey
                ? formatMessage(
                    tableCell.value,
                    formatPriceWithVatRate(
                      get(domesticPrices, tableCell.priceKeyWithVatRate),
                      get(domesticPrices, tableCell.priceKey)
                    )
                  )
                : tableCell.value;
              return <TableCell key={index}>{value}</TableCell>;
            })}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default ContentTable;
